import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48aa1098"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tw-fixed tw-flex tw-flex-col tw-inset-0 tw-bg-white tw-z-10" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-relative tw-top-0 tw-left-0 tw-w-full tw-h-[68px]" }, null, -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "tw-fixed tw-z-50 tw-top-0 tw-left-0 tw-w-full tw-h-[68px] tw-bg-primary" }
const _hoisted_6 = { class: "tw-text-mainbg1 tw-text-center tw-py-[18px] tw-overflow-hidden tw-text-xl" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  ref: "mathTestUi",
  class: "mathsui"
}
const _hoisted_9 = { class: "sf-modal-body" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Test Results", -1))
const _hoisted_11 = { class: "sf-modal-footer" }
const _hoisted_12 = { class: "sf-modal-body" }
const _hoisted_13 = { class: "tw-text-center tw-mb-8" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "tw-text-center tw-w-full"
}
const _hoisted_16 = {
  key: 0,
  class: "tw-flex tw-justify-center tw-gap-4"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-text-center" }, " Your Answer ", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 0,
  class: "maths-correct-answer-box"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-text-center tw-font-bold tw-text-okcheck tw-mb-2" }, " Correct Answer ", -1))
const _hoisted_21 = {
  ref: "nextButton",
  class: "tw-mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SfActivityMain = _resolveComponent("SfActivityMain")!
  const _component_MathsTestResult = _resolveComponent("MathsTestResult")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!
  const _component_RenderMathAnswer = _resolveComponent("RenderMathAnswer")!
  const _component_RenderMathQuestion = _resolveComponent("RenderMathQuestion")!
  const _component_MathAnswerForm = _resolveComponent("MathAnswerForm")!
  const _component_CheckSvg = _resolveComponent("CheckSvg")!
  const _component_XSvg = _resolveComponent("XSvg")!
  const _component_ScoreSaveErrorHandler = _resolveComponent("ScoreSaveErrorHandler")!
  const _component_GameCloseConfirm = _resolveComponent("GameCloseConfirm")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.game)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("iframe", {
              src: _ctx.game.url,
              class: "tw-grow tw-w-full"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCloseActivityRequest && _ctx.onCloseActivityRequest(...args))),
              class: "tw-block tw-absolute tw-top-2 tw-right-3 sf-btn tw-bg-mainbg1 tw-text-primary hover:tw-outline-primary"
            }, " CLOSE "),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.game.name), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showActivityMain)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_SfActivityMain, { onClose: _ctx.onCloseActivityRequest }, null, 8, ["onClose"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_ModalDialog, {
            show: _ctx.mathProgress?.completed && _ctx.mathResultsVisible,
            title: "Test Completed",
            "prevent-body-scroll": false,
            onClosed: _ctx.closeMathResults
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_MathsTestResult, {
                  result: _ctx.mathProgress,
                  student: _ctx.$currentUser.value
                }, null, 8, ["result", "student"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "sf-btn-primary",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeMathResults && _ctx.closeMathResults(...args)), ["prevent"]))
                }, " Close ")
              ])
            ]),
            _: 1
          }, 8, ["show", "onClosed"]),
          _createVNode(_component_ModalDialog, {
            show: _ctx.mathQuestionVisible,
            "can-close": false,
            onClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mathQuestionVisible = false)),
            "prevent-body-scroll": false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.questionStep =='answer' &&
                _ctx.answerResult &&
                _ctx.answerResult.answerFeedback)
                    ? (_openBlock(), _createBlock(_component_RenderMathAnswer, {
                        key: 0,
                        answer: _ctx.answerResult.answer,
                        "answer-render-kind": _ctx.answerResult.answerFeedback.kind,
                        "answer-render": _ctx.answerResult.answerFeedback?.render?.correct,
                        question: _ctx.mathCurrentQuestion,
                        formats: _ctx.answerFormats,
                        class: "tw-mx-auto"
                      }, null, 8, ["answer", "answer-render-kind", "answer-render", "question", "formats"]))
                    : (_openBlock(), _createBlock(_component_RenderMathQuestion, {
                        key: 1,
                        "question-kind": _ctx.mathCurrentQuestion.questionKind || 'text',
                        question: _ctx.mathCurrentQuestion.question || '',
                        "answer-fields": _ctx.mathCurrentQuestion.answerFields,
                        class: "tw-mx-auto"
                      }, null, 8, ["question-kind", "question", "answer-fields"]))
                ]),
                (_ctx.questionStep == 'question')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_MathAnswerForm, {
                          question: _ctx.mathCurrentQuestion,
                          "test-ui-element": _ctx.mathTestUi,
                          onSubmit: _ctx.handleMathAnswer
                        }, null, 8, ["question", "test-ui-element", "onSubmit"])
                      ])
                    ]))
                  : (_ctx.questionStep == 'answer')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        (_ctx.answerResult)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("div", null, [
                                (_ctx.answerResult.isCorrect)
                                  ? (_openBlock(), _createBlock(_component_CheckSvg, {
                                      key: 0,
                                      scale: 1,
                                      class: "result-ok tw-block tw-mx-auto"
                                    }))
                                  : (_openBlock(), _createBlock(_component_XSvg, {
                                      key: 1,
                                      scale: 1,
                                      class: "result-wrong tw-block tw-mx-auto"
                                    }))
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", {
                                  class: _normalizeClass({
                    'maths-wrong-answer-box': !_ctx.answerResult.isCorrect,
                    'maths-correct-answer-box': _ctx.answerResult.isCorrect,
                  })
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["tw-font-bold tw-mb-2", {
                      'tw-text-okcheck': _ctx.answerResult.isCorrect,
                      'tw-text-danger': !_ctx.answerResult.isCorrect,
                    }])
                                  }, _hoisted_18, 2),
                                  _createVNode(_component_RenderMathAnswer, {
                                    answer: _ctx.answerResult.answer,
                                    "answer-render-kind": _ctx.answerResult.answerRender?.kind,
                                    "answer-render": _ctx.answerResult.answerRender?.render?.answer,
                                    question: _ctx.mathCurrentQuestion,
                                    formats: _ctx.answerFormats
                                  }, null, 8, ["answer", "answer-render-kind", "answer-render", "question", "formats"])
                                ], 2)
                              ]),
                              _createElementVNode("div", null, [
                                (!_ctx.answerResult.isCorrect)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _hoisted_20,
                                      _createVNode(_component_RenderMathAnswer, {
                                        answer: _ctx.answerResult.correctAnswer,
                                        "answer-render-kind": _ctx.answerResult.answerRender?.kind,
                                        "answer-render": _ctx.answerResult.answerRender?.render?.correct,
                                        question: _ctx.mathCurrentQuestion
                                      }, null, 8, ["answer", "answer-render-kind", "answer-render", "question"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("button", {
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.continueToNextQuestion && _ctx.continueToNextQuestion(...args))),
                            class: "sf-btn-primary"
                          }, " Next ")
                        ], 512)
                      ]))
                    : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["show"])
        ], 512)),
    _createVNode(_component_ScoreSaveErrorHandler, {
      subject: _ctx.isMaths ? 'maths' : 'spelling',
      onShowmathresults: _ctx.showMathResults,
      onMathsaved: _ctx.onAnswerChecked
    }, null, 8, ["subject", "onShowmathresults", "onMathsaved"]),
    _createVNode(_component_GameCloseConfirm, {
      show: _ctx.confirmCloseVisible,
      "is-maths": _ctx.isMaths,
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmCloseVisible = false)),
      onClose: _cache[5] || (_cache[5] = ($event: any) => {_ctx.closeActivity(); _ctx.confirmCloseVisible = false;})
    }, null, 8, ["show", "is-maths"])
  ]))
}